<a class="product btn btn-light" [ngClass]="{'new-in': newIn}" (click)="goToPDP(product.sapCode)">
  <div class="header">
    @if(product.isNewIn){
    {{'New'|translate}}
    }@else if(product.reproducibility){
    {{product.reproducibility}}
    }@else if(product.lowPriorityJewelry){
    <!-- {{"Low Priority"|translate}} -->
    {{'S'+product.classification}}
    }
  </div>

  <div class="img-wrapper">
    <app-asset [assetSrc]="product.media"></app-asset>
  </div>

  <div class="footer">

    <div class="text">
      <span>{{product.sapCode}}</span>
      <span class="catalog-code">{{product.catalogCode}}</span>
    </div>

    @if(!isInSearchPage){

    @if((authService.user?.isUserStore || authService.user?.isUserBp) && !product.isHJ){

    <div class="text price">

      @if(price()){

      {{priceLabel()}}

      }@else {

      @if(loading()){

      <div class="spinner-border text-primary mx-auto" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>

      }@else if(product.canShowPrice && price() === undefined){

      <a class="btn btn-link" type="button" (click)="loadPrice($event, product.sapCode)">
        {{"Show price"}}
      </a>

      }@else if(newIn) {

      {{product.catalogCode}}

      }@else{ N/A }

      }

    </div>

    }

    }

  </div>

</a>
